import React from 'react';
import { useSelector } from 'react-redux';
import { Button } from '@americanexpress/dls-react';
import { getOneCmsLoungeFinderImagesBaseUrl } from '@/selectors/oneCmsSelectors';
import { getLoginUrl } from '@/selectors/configSelectors';
import { useCommonContent } from '@/hooks/oneCmsIntlHooks/oneCmsIntlHelperHooks';
import { useRouteParams } from '@/context/routeParamsContext';
import DividerWithMessage from './DividerWithMessage';

const LoginCard = () => {
  const baseOneCmsImgUrl = useSelector(getOneCmsLoungeFinderImagesBaseUrl);
  const loginOrigin = useSelector(getLoginUrl);
  const { locale } = useRouteParams();
  const { login, selectCard } = useCommonContent();

  const handleClick = () => {
    const returnUrl = window.location.href;
    const fullUrl = `${loginOrigin}/${locale}/account/login?DestPage=${encodeURIComponent(returnUrl)}`;
    window.location.assign(fullUrl);
  };

  return (
    <>
      <div
        className="tw-border-blue-deep-tint-t12 tw-mb-6 tw-rounded-lg tw-bg-blue-deep-700 tw-bg-contain tw-bg-no-repeat tw-p-6 sm_tw-flex sm_tw-gap-4"
        style={{
          backgroundImage: `url(${baseOneCmsImgUrl}amex-logo-accent.png)`,
        }}
      >
        <div className="sm_tw-mb-0 sm_tw-flex sm_tw-flex-col">
          <p className="tw-heading-xs-bold tw-text-gray-100">{login?.header}</p>
          <p className="tw-text-gray-200">{login?.label}</p>
        </div>
        <Button
          variant="primary"
          className="tw-ml-auto tw-mt-4 tw-w-full sm_tw-mt-0 sm_tw-w-auto"
          onClick={handleClick}
        >
          {login?.button}
        </Button>
      </div>
      <DividerWithMessage message={selectCard?.divider} />
    </>
  );
};

export default LoginCard;
